import { render, staticRenderFns } from "./scope-switch.vue?vue&type=template&id=51607b6c&lang=html&"
import script from "./scope-switch.vue?vue&type=script&lang=js&"
export * from "./scope-switch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports